angular.module('lf.desktop')

.directive('customScrollbars', function () {
  return function (scope, el, attrs) {
    var $el = $(el);
    
    setTimeout(function () {
      $el.mCustomScrollbar({
        scrollInertia: 400,
        advanced:{
          updateOnContentResize: true
        }
      });
    }, 50);
    
    scope.$on('$destroy', function () {
      $el.mCustomScrollbar('destroy');
    });
  }
});
